import React from "react";
import useStyles from "./Main.css";

export default function Main(props: any) {
  const { nofityRequestNumber, setNofityRequestNumber } = props;
  const classes = useStyles();
  const childrenWithAdjustedProps = React.Children.map(
    props.children,
    (child) => React.cloneElement(child, { nofityRequestNumber, setNofityRequestNumber })
  );
  return (
    <div>
      <div className={classes.content}>
        <div className={classes.toolbar} />
        {childrenWithAdjustedProps}
      </div>
    </div>
  );
}
